import type { LegendItem } from 'chart.js'

/**
 * MD-2610-1383 — กราฟแนวโน้มรายได้: เส้นประเป้าหมาย (dataset ที่ 2) ถูกแท่งรายได้ (dataset ที่ 1) บัง
 * เดือน/สาขาที่รายได้ถึงหรือเกินเป้าจึงมองไม่เห็นเส้น — Chart.js วาด dataset ที่ `order` น้อยกว่าทีหลัง (อยู่บน)
 * ค่าเริ่มต้นทุกชุดเป็น 0 → ชุดแรก (แท่ง) อยู่บนสุด จึงให้เส้นเป้า order 1 แท่ง order 2
 * `order` ยังมีผลกับลำดับ legend → เรียง legend กลับตามลำดับ dataset เดิม ("รายได้รวม (สุทธิ) · เป้าหมาย")
 */
export const REVENUE_TREND_ORDER = { bar: 2, targetLine: 1 } as const

export const legendSortByDatasetIndex = (a: Pick<LegendItem, 'datasetIndex'>, b: Pick<LegendItem, 'datasetIndex'>): number =>
  (a.datasetIndex ?? 0) - (b.datasetIndex ?? 0)
